var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9688 42V13.9688H16.0312V42H37.9688ZM37.9688 10.0312C39.0312 10.0312 39.9688 10.4375 40.7812 11.25C41.5938 12 42 12.9062 42 13.9688V42C42 43.0625 41.5938 44 40.7812 44.8125C39.9688 45.625 39.0312 46.0312 37.9688 46.0312H16.0312C14.9688 46.0312 14.0312 45.625 13.2188 44.8125C12.4062 44 12 43.0625 12 42V13.9688C12 12.9062 12.4062 12 13.2188 11.25C14.0312 10.4375 14.9688 10.0312 16.0312 10.0312H37.9688ZM31.9688 1.96875V6H7.96875V34.0312H4.03125V6C4.03125 4.9375 4.40625 4 5.15625 3.1875C5.96875 2.375 6.90625 1.96875 7.96875 1.96875H31.9688Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content_copy.1241f016b057c094bba936988bd3df70.svg";
export { ForwardRef as ReactComponent };